import { TFunction } from 'i18next';

import { RestResponse } from '../../core/types/response/RestResponse';
import { RestErrorResponse } from '../../core/types/response/RestErrorResponse';
import { AuthResponse } from '../../core/state/auth/types';
import { LoginErrorCode } from '../../core/enums/LoginErrorCode';
import { GlobalNotificationTypes } from '../../core/enums/GlobalNotificationTypes';

export const createErrorNotificationContent = (response: RestResponse<RestErrorResponse | AuthResponse>, t: TFunction) => {
  const { errorCode, errorTitle, errorMessage } = response.data.result;
  let title = '';
  let message = '';

  switch (errorCode) {
    case LoginErrorCode.NoUser:
      title = t('login.validation.account.missing.title');
      message = t('login.validation.account.missing.message');
      break;
    case LoginErrorCode.UserNotActive:
      title = t('login.validation.account.not.active.title');
      message = t('login.validation.account.not.active.message');
      break;
    case LoginErrorCode.WrongPassword:
      title = t('login.validation.account.wrong.password.title');
      message = t('login.validation.account.wrong.password.message');
      break;
    case LoginErrorCode.UserLocked:
      title = t('login.validation.account.locked.title');
      message = t('login.validation.account.locked.message');
      break;
    case LoginErrorCode.ProjectInactive:
      title = t('login.validation.account.inactive.project.title');
      message = t('login.validation.account.inactive.project.message');
      break;
    case LoginErrorCode.UserNotInvited:
      title = t('login.validation.account.not.invited.title');
      message = t('login.validation.account.not.invited.message');
      break;
    default:
      title = errorTitle;
      message = errorMessage;
  }

  return {
    type: GlobalNotificationTypes.Error,
    title,
    message,
    autoHide: false
  };
};
